import { render, staticRenderFns } from "./SolicitorCaseDetailsTab.vue?vue&type=template&id=14cf716c"
import script from "./SolicitorCaseDetailsTab.vue?vue&type=script&lang=js"
export * from "./SolicitorCaseDetailsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports